import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-icon-circle',
    templateUrl: './icon-circle.component.html',
    styleUrl: './icon-circle.component.scss',
    standalone: true,
    imports: [
        MatIconModule, CommonModule
    ]
})
export class IconCircleComponent {

    @Input() scale: string = "0.84"
    @Input() iconClass: string = ""
    @Input() big: boolean = false;
    @Input() stateColor: string | null = null

    iconBg!: string

    constructor() { }

    ngOnInit(): void {
        this.iconBg = this.iconClass + "-bg"
    }

    get currentIconClass(): string {
        if (this.iconClass == '') {
            return 'material-icons'
        }
        return 'material-icons ' + this.iconClass
    }
}
